/**
 * @generated SignedSource<<273af7d6c523b1c6dec8216fe69ce2b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSystemRelayQuery$variables = {
  id: string;
};
export type useSystemRelayQuery$data = {
  readonly getSystem: {
    readonly id: string;
    readonly name: string | null | undefined;
    readonly newHardware: boolean | null | undefined;
    readonly oldId: string | null | undefined;
    readonly rentableHardwareType: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly namePlural: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSystemRelayQuery = {
  response: useSystemRelayQuery$data;
  variables: useSystemRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "System",
    "kind": "LinkedField",
    "name": "getSystem",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oldId",
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newHardware",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "HardwareType",
        "kind": "LinkedField",
        "name": "rentableHardwareType",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "namePlural",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSystemRelayQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSystemRelayQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6abe89d26689d9c8657e38cf67a146cf",
    "id": null,
    "metadata": {},
    "name": "useSystemRelayQuery",
    "operationKind": "query",
    "text": "query useSystemRelayQuery(\n  $id: ID!\n) {\n  getSystem(id: $id) {\n    id\n    oldId\n    name\n    newHardware\n    rentableHardwareType {\n      id\n      name\n      namePlural\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0720ebd62035205944a1f57035add1c5";

export default node;
